import React from 'react'
import { Tag } from '@chakra-ui/react'

export default ({ colorPalette, size, variant, label, bg, color, onClose, onClick, children }) => {
  return (
    <Tag.Root variant={variant} size={size} colorPalette={colorPalette} color={color} bg={bg} onClick={onClick}>
      <Tag.Label>{label || children}</Tag.Label>
      {onClose &&
        <Tag.EndElement>
          {/* The close trigger sits inside the (optionally clickable) tag root,
              so stop the click bubbling up and firing onClick as well. */}
          <Tag.CloseTrigger
            cursor='pointer'
            onClick={e => {
              e.preventDefault()
              e.stopPropagation()
              onClose(e)
            }}
          />
        </Tag.EndElement>}
    </Tag.Root>
  )
}
